import Hammer from "hammerjs";

import { DISMISS_THRESHOLD_PX, SWIPE_VELOCITY } from "./config";

export type SwipeDirection = "left" | "right" | "up" | "down";

export type SwipeBindingOptions = {
  direction: number;
  threshold?: number;
  velocity?: number;
  touchAction?: string;
};

export type SwipeBinding = Partial<Record<SwipeDirection, (event: HammerInput) => void>>;

const managerCache = new WeakMap<HTMLElement, HammerManager>();

export function createGestureManager(element: HTMLElement): HammerManager {
  const cached = managerCache.get(element);
  if (cached) {
    return cached;
  }
  const manager = new Hammer.Manager(element);
  managerCache.set(element, manager);
  return manager;
}

export function bindSwipeGesture(
  element: HTMLElement,
  callbacks: SwipeBinding,
  options: SwipeBindingOptions,
): HammerManager {
  const manager = createGestureManager(element);
  const existing = manager.get("swipe");
  const config = {
    direction: options.direction,
    threshold: options.threshold ?? DISMISS_THRESHOLD_PX,
    velocity: options.velocity ?? SWIPE_VELOCITY,
  };

  if (existing) {
    existing.set(config);
  } else {
    manager.add(new Hammer.Swipe(config));
  }

  manager.set({ touchAction: options.touchAction ?? "auto" });

  if (callbacks.left) {
    manager.on("swipeleft", callbacks.left);
  }
  if (callbacks.right) {
    manager.on("swiperight", callbacks.right);
  }
  if (callbacks.up) {
    manager.on("swipeup", callbacks.up);
  }
  if (callbacks.down) {
    manager.on("swipedown", callbacks.down);
  }

  return manager;
}
